import { useNavigate } from "react-router-dom";
import { ShieldCheck, Building2, ChevronLeft, ChevronRight, BadgeCheck } from "lucide-react";
import { useCachedGet } from "@/lib/cache";
import { imageUrl } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const OFFICE_SUBTITLE = {
  domestic_workers: ["مركز معتمد لدى إدارة بازارو ومرخّص في دولة الإمارات العربية المتحدة", "Centre approved by Bazaroo and licensed in the United Arab Emirates"],
  home_services: ["نشاط مرخص ومعتمد لدى بازارو ومرخص في دولة الإمارات العربية المتحدة", "Licensed activity approved by Bazaroo and licensed in the United Arab Emirates"],
};

export const OfficeLogo = ({ src, size = "w-16 h-16" }) => (
  <div className={`${size} rounded-2xl bg-white border border-[#E3EDE7] overflow-hidden flex items-center justify-center shrink-0 shadow-sm`}>
    {src ? <img src={imageUrl(src)} alt="" className="w-full h-full object-contain p-1" /> : <Building2 className="w-7 h-7 text-[#1A5C3A]" />}
  </div>
);

// Replaces the personal seller card for domestic-workers & home-services ads (no personal data shown).
export function OfficeCard({ listing }) {
  const navigate = useNavigate();
  const { lang, dir } = useLang();
  const T = (ar, en) => (lang === "en" ? en : ar);
  const { data: b } = useCachedGet(`/business/${listing.business_id}/public`, null, { enabled: !!listing.business_id });
  const Chevron = dir === "rtl" ? ChevronLeft : ChevronRight;
  const name = (lang === "en" ? b?.name_en : b?.name_ar) || listing.business_name;
  const sub = OFFICE_SUBTITLE[listing.category] || OFFICE_SUBTITLE.home_services;
  if (!listing.business_id) return null;
  return (
    <section className="relative overflow-hidden rounded-3xl border border-[#CFE3D7] bg-gradient-to-b from-[#F1F8F4] to-white p-5" data-testid="office-card">
      <span className="absolute top-0 inset-x-0 h-1 bg-[#1A5C3A]" />
      <div className="flex items-center gap-4">
        <OfficeLogo src={b?.logo} size="w-24 h-24 sm:w-28 sm:h-28" />
        <div className="min-w-0 flex-1">
          <p className="font-headline font-extrabold text-slate-900 text-lg leading-snug flex items-center gap-1.5" data-testid="office-name">
            <span className="truncate">{name}</span><BadgeCheck className="w-5 h-5 text-[#1A5C3A] shrink-0" />
          </p>
          <p className="text-sm font-semibold text-slate-700 leading-relaxed mt-1.5" data-testid="office-subtitle">{T(...sub)}</p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-2 text-sm font-extrabold text-[#1A5C3A] bg-[#E3F0E8] rounded-xl px-3.5 py-2.5" data-testid="office-trust">
        <ShieldCheck className="w-5 h-5 shrink-0" />{T("مكتب موثّق · رخصة تجارية سارية", "Verified office · valid trade licence")}
      </div>
      <button onClick={() => navigate(`/center/${listing.business_id}`)} className="mt-3 w-full flex items-center justify-between text-sm font-bold text-white bg-[#1A5C3A] hover:bg-[#154a2f] transition-colors rounded-xl px-4 h-11" data-testid="office-view-page">
        {T("عرض صفحة المكتب كاملة", "View full office page")}<Chevron className="w-4 h-4" />
      </button>
    </section>
  );
}
